<template>

  <v-main fill-height :style="(background)?{'background': background}:{}">
     <v-container fill-height fluid class="pa-0" :class="{'px-2':isSmAndDownDevice}">
      <v-layout align-center justify-center>
        <div class="fullscreen">
          <EspFreeDraw 
          :background="canvasBackground"
          :width="`${bgWidth}px`" 
          :height="`${bgHeight*0.8}px`"/>
        </div>
      </v-layout>
     </v-container>
  </v-main>
</template>

<script>
import {layoutMixin} from '@/utils/layout-mixin'
import CONFIG from '@/constants/config.js'
import EspFreeDraw from '@/components/draw/EspFreeDraw.vue'
export default {
  mixins: [layoutMixin],
  components:{
    EspFreeDraw
  },
  data() {
    return {
      
    }
  },
  computed: {
    background(){
      return this.theme.espotoGrey;
    },
    canvasBackground(){
      return CONFIG.FEATURE_DRAWING.url
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.fullscreen{
  position:absolute;
  top:30px;
  left:0;
  right:0;
  bottom:0px;
  overflow:auto;
}
</style>
